import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import {
  PercentPositiveRunDateComponent, BaseComponent, QueryService, SearchService, TitleService, FilterService, ReportKeys, DateGroupType,
  TestResult_PercentPositiveByRunDateRow
} from '../../core';
import { NgxMatToastService } from 'ngx-mat-toast';
import { TranslateService } from '@ngx-translate/core';
import { MatRadioChange } from '@angular/material/radio';
import { GoogleAnalyticsService } from '../../core/services/google-analytics.service';
import { translate } from 'src/app/core/utils/translateServiceHelper';

@Component({
  selector: 'app-report-percent-positive-run-date',
  templateUrl: './report-percent-positive-run-date.component.html',
  styleUrls: ['./report-percent-positive-run-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportPercentPositiveRunDateComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('chart', { static: true }) private percentPositiveRunDate: PercentPositiveRunDateComponent;

  public selectedValue: DateGroupType;
  public DateGroupType = DateGroupType;

  constructor(private queryService: QueryService,
    private searchService: SearchService,
    private titleService: TitleService,
    private filterService: FilterService,
    private toastr: NgxMatToastService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private translate: TranslateService) {
    super();

    this.selectedValue = DateGroupType.Month;
  }


  ngOnInit(): void {

    this.subscription.add(this.queryService.filtersApplied.subscribe((filtersApplied: boolean) => {
      console.debug(`Filters applied: ${filtersApplied}`);
    }));

    this.subscription.add(this.queryService.searchRequested.subscribe(() => {
      this.onSearch();
    }));

    this.onSearch();

    this.titleService.updateTitleTranslateKey('ReportMenu.PercentPositiveResults');
  }

  onChange(changeValue: MatRadioChange): void {
    this.selectedValue = changeValue.value as DateGroupType;
    console.debug('test');
    this.onSearch();
  }

  onSearch(): void {
    if (this.filterService.isReportEnabled(ReportKeys.PercentPositiveResults)) {
      this.googleAnalyticsService.logWithLabels('View Report', 'Report', 'View Patient Positive By Run Date Report', 'filters', this.queryService.getCurrentQuery(true), 'groupType', this.googleAnalyticsService.getDateGroupType(this.selectedValue));
      this.subscription.add(this.searchService.getReportPercentPositiveByRunDate(
        {
          query: this.queryService.getCurrentQuery(true),
          dateGroupType: this.selectedValue
        })
        .subscribe(
          (result: TestResult_PercentPositiveByRunDateRow[]) => {
            if (!result || result.length === 0) {
              const title = translate(this.translate, 'ReportMenu.NoDataToShow');
              this.toastr.info(title);
              return;
            }

            this.percentPositiveRunDate.setData(result);
          }));
    } else {
      const message = translate(this.translate, 'ReportMenu.RequirePatient');
      const title = translate(this.translate, 'ReportMenu.ReportLoadError');
      this.toastr.error(message, title);
    }
  }

  ngOnDestroyInternal(): void {
    // Required by base component
  }

  savePDF(): void {
    this.percentPositiveRunDate.saveAsPdf();
  }

  saveImage(): void {
    this.percentPositiveRunDate.saveAsImage();
  }

}
